import { pickThemeColor, pickThemeFontSize } from '@/theme';
import { Upload } from 'antd';
import styled from 'styled-components';

export const StyledUploadSelect = styled(Upload)`
  .ant-upload-select {
    display: block;
  }
`;

export const StyledIcon = styled.span`
  .anticon {
    color: ${pickThemeColor('GREY')};
    font-size: ${pickThemeFontSize('20')};
  }
`;

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-grow: 1;
`;
